(function ($, window, document) {
    'use strict';

    window.AdminKit = window.AdminKit || {};

    window.AdminKit.theme = {
        init: function () {
            var savedTheme = localStorage.getItem('admin_theme') || 'light';

            this.apply(savedTheme);

            $('.theme-toggle').on('click', function () {
                var nextTheme = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';

                window.AdminKit.theme.apply(nextTheme);
                localStorage.setItem('admin_theme', nextTheme);
            });
        },

        apply: function (theme) {
            document.documentElement.setAttribute('data-theme', theme);

            $('.theme-toggle i')
                .toggleClass('fa-moon', theme !== 'dark')
                .toggleClass('fa-sun', theme === 'dark');
        }
    };
})(jQuery, window, document);
